import { Link } from "react-router-dom";
import { withEditorMode } from "../navigation/editorModes";
import { journeyForRoute } from "./authoringJourneys";

function sameTarget(route: string, pathname: string, search: string) {
  const target = new URL(route, "https://editor.invalid");
  if (target.pathname !== pathname) return false;
  const actual = new URLSearchParams(search);
  return [...target.searchParams].every(([key, value]) => actual.get(key) === value);
}

export function JourneyWorkflowBar({ pathname, search }: { pathname: string; search: string }) {
  const journey = journeyForRoute(pathname, search);
  if (!journey) return null;
  const matched = journey.steps.findIndex((step) => sameTarget(step.route, pathname, search));
  const activeIndex = matched < 0 ? 0 : matched;
  return <section className="journey-workflow-bar" aria-label={`${journey.label} production workflow`}>
    <header><div><small>GAME-MAKING WORKFLOW</small><strong>{journey.label}</strong></div><span>Step {activeIndex + 1} of {journey.steps.length}</span></header>
    <ol>{journey.steps.map((step, index) => <li key={step.id} data-active={index === activeIndex || undefined} data-complete={index < activeIndex || undefined}><Link to={withEditorMode(step.route, "simple")}><i>{index + 1}</i><span><strong>{step.label}</strong><small>{step.description}</small></span></Link></li>)}</ol>
    <footer><Link to={withEditorMode("/validation", "simple")}>Review readiness</Link><Link className="primary" to={withEditorMode("/publishing", "simple")}>Apply to Live</Link></footer>
  </section>;
}
